"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  sidekick: {
    extensionUrl: 'https://chrome.google.com/webstore/detail/oiiaigjnkhngdbnoookogelabohpglmd'
  }
};
exports.default = _default;
module.exports = exports.default;